module.exports = __webpack_public_path__ + "img/jp.8f51b53b.svg";